import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CapitalizePipe } from 'app/shared/capitalize.pipe';
import { CEUMA_URL_API } from 'app/config';

import { AgendamentosDTO, AgendamentosCampusDisponiveis, AgendamentosDatasPorCampus } from 'models/agendamentos';

export const AGENDAMENTO_API_URL = CEUMA_URL_API + '/agendamentos';
export const RECUPERA_CAMPUS_DISPONIVEIS_AGENDAMENTO_URL = CEUMA_URL_API + '/recuperaCampusDisponiveisParaAgendamento';
export const RECUPERA_CAMPUS_DISPONIVEI_AGENDAMENTO_URL = CEUMA_URL_API + '/recuperaDatasDisponiveisParaAgendamento';

const cropHora = (hora: string) => {
  if (!hora) {
    return '';
  }
  const horaParts = hora.split(':');
  return `${horaParts[0]}:${horaParts[1]}`;
};

@Injectable()
export class AgendamentoService {

  private capitalizaPipe = new CapitalizePipe();

  constructor(private http: HttpClient) { }

  buscarAgendamentos(id: string, ano: string, sigla: string): Promise<AgendamentosDTO> {
    const url = `${AGENDAMENTO_API_URL}/${ano}/${id}/${sigla}`;

    return new Promise<AgendamentosDTO>((resolve, reject) => {
      this.http.get(url).subscribe((agendamento: any) => {
        if (!agendamento || agendamento.codigo) {
          // error
          reject({ error: agendamento });
        } else {

          // tratamento de informacoes
          agendamento.campus = agendamento.campus.map(campus => {
            let descricao = campus.descricao.toLowerCase();
            if (descricao && descricao.indexOf('polo') === -1 && descricao.indexOf('campus') === -1) {
              descricao = `campus ${descricao}`;
            }
            descricao = this.capitalizaPipe.transform(descricao, { todasPalavras: true });
            return Object.assign(campus, { descricao });
          });

          for (const dia of agendamento.dia) {
            if (dia.hora) {
              dia.hora.horaInicial = cropHora(dia.hora.horaInicial);
              dia.hora.horaFinal = cropHora(dia.hora.horaFinal);
            }
          }
          resolve(AgendamentosDTO.convertAgendamentosToAgendamentosDTO(agendamento));
        }
      });
    });
  }

  buscarCampusAgendamento(sigla: string) {
    const url = `${RECUPERA_CAMPUS_DISPONIVEIS_AGENDAMENTO_URL}/${sigla}`;

    return this.http.get(url).toPromise()
      .then((campusAgendamento: any) => {

        // tratamento de informacoes
        campusAgendamento.campus = campusAgendamento.map(campus => {
          let descricao = campus.descricao.toLowerCase();
          if (descricao && descricao.indexOf('polo') === -1 && descricao.indexOf('campus') === -1) {
            descricao = `campus ${descricao}`;
          }
          descricao = this.capitalizaPipe.transform(descricao, { todasPalavras: true });
          return Object.assign(campus, { descricao });
        });
        return new AgendamentosCampusDisponiveis(campusAgendamento);
      })
      .catch(error => {
        console.error(error);
      });
  }

  buscarDatasDisponiveis(ano: string, codigo: string, campus: string) {
    const url = `${RECUPERA_CAMPUS_DISPONIVEI_AGENDAMENTO_URL}/${ano}/${codigo}/${campus}`;

    return this.http.get(url).toPromise()
      .then((datas: any) => {
        // tratamento de informacoes
        datas.map(dia => {
          if (dia.hora) {
            dia.hora.horaInicial = cropHora(dia.hora.horaInicial);
            dia.hora.horaFinal = cropHora(dia.hora.horaFinal);
          }
        });
        return AgendamentosDatasPorCampus.convertAgendamentosToAgendamentosDTO(datas);
      })
      .catch(error => {
        console.error(error);
      });
  }
}
